export enum THREE_DOTS_ITEM_TYPE {
    PLAIN = 'plain',
    ACTION = 'action',
    WARNED = 'warned',
    STRICT_WARNED = 'strict-warned',
}

export enum THREE_DOTS_VIEW {
    CLEAR = 'clear',
    PSEUDO = 'pseudo',
}
